enum UploadContexts {
  ATTACHMENTS = 'attachments',
  IMPORTS = 'imports_v2',
}

export default UploadContexts;
